import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ProjectSections } from '../../constants/project-settings';
import { ProjectStatus } from '../../data/models/project-status';
import { ProjectService } from '../../data/project/project.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-project-bucket-slider',
    templateUrl: './project-bucket-slider.component.html',
    styleUrls: ['./project-bucket-slider.component.scss'],
    standalone: false
})
export class ProjectBucketSliderComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('container', { static: false, read: ElementRef }) container: ElementRef;

  @Input() projects: any;
  @Input() totalCards: number;
  @Input() expansionTitle: string;
  @Input() isPaggination = false;

  currentPage = 1;
  pagePosition = '0%';
  cardsPerPage: number;
  totalPages: number;
  overflowWidth: string;
  cardWidth: string;
  containerWidth: number;
  cardMargin = 1.5;

  // Initial project tile width as per mockup in px
  initialCardWidth = 414;

  pageCount = 1;
  maxWidth = 100;
  navigatedPages: string;
  projectSections = ProjectSections;
  sortProjectsMenuValue: ProjectStatus[] = [];
  subscriptions: Subscription[] = [];
  selectedSort: string;
  // Display project tile as per window resolution //

  @HostListener('window:resize') windowResize(): void {
    const newCardsPerPage = this.getCardsPerPage();
    if (newCardsPerPage != this.cardsPerPage) {
      this.cardsPerPage = newCardsPerPage;
      this.initializeSlider();
      if (this.currentPage > this.totalPages) {
        this.currentPage = this.totalPages;
        this.populatePagePosition();
      }
    }
  }
  constructor(private projectDataService: ProjectService) {}

  ngOnInit(): void {
    this.sortProjectsMenuValue = this.projectDataService.sortProjectsMenuValue;
  }

  ngAfterViewInit(): void {
    this.cardsPerPage = this.getCardsPerPage();
    this.initializeSlider();
  }

  initializeSlider(): void {
    this.totalPages = this.isPaggination ? Math.ceil(this.totalCards / this.cardsPerPage) : this.pageCount;
    this.overflowWidth = `calc(${this.totalPages * this.maxWidth}% + ${this.totalPages * this.cardMargin}rem)`;
    this.cardWidth = `calc((${this.maxWidth / this.totalPages}% - ${this.cardsPerPage * this.cardMargin}rem) / ${
      this.cardsPerPage
    })`;
    this.navigatedPages = this.createPaginationText();
  }

  getCardsPerPage(): number {
    const offsetWidth = this.container.nativeElement.offsetWidth;
    return Math.floor(offsetWidth / this.initialCardWidth);
  }

  changePage(incrementor: number): void {
    this.currentPage += incrementor;
    this.navigatedPages = this.createPaginationText();
    this.populatePagePosition();
  }

  populatePagePosition(): void {
    this.pagePosition = `calc(${-this.maxWidth * (this.currentPage - this.pageCount)}% - ${
      this.cardMargin * (this.currentPage - this.pageCount)
    }rem)`;
  }

  // Creating pagination navigation numbers //
  createPaginationText(): string {
    if (this.totalCards === 0) {
      return `${this.totalCards} - ${this.totalCards}`;
    } else if (this.currentPage === this.pageCount) {
      return `${this.currentPage} - ${this.currentPage * this.cardsPerPage}`;
    } else if (this.currentPage === this.totalPages) {
      return `${this.currentPage * this.cardsPerPage - (this.cardsPerPage - this.pageCount)} - ${this.totalCards}`;
    } else {
      return `${this.currentPage * this.cardsPerPage - (this.cardsPerPage - this.pageCount)} - ${
        this.currentPage * this.cardsPerPage
      }`;
    }
  }

  updateTileViewSortValue(value: ProjectStatus): void {
    this.selectedSort = value.name;
    this.projectDataService.updateTileViewSortValue(value);
  }

  ngOnDestroy(): void {
    // prevent memory leak when component destroyed
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
